import Login from "@Front/Components/Layouts/Login";

export default function Route(): React.JSX.Element {
	return <Login />;
}
